import AxiosInterceptor from "../../AxiosInterceptorAlcohol";

export function getInstitutionsFromAlcohol() {
	return AxiosInterceptor({ url: '/base/institution', method: 'get', timeout: 15000 });
}

// 알코지니 관리자 서비스의 사용자 정보를 조회
export function getUserInfoFromAlcohol() {
	return AxiosInterceptor({
		url: '/signup/dpdtx001admin',
		method: 'get'
	})
}

// 알코지니 사용자 프로필 이미지 조회
export function getUserProfileImageFromAlcohol() {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'get'
	})
}

// 알코지니 사용자 프로필 이미지 업로드
export function putUserProfileImageToAlcohol(request) {
	return AxiosInterceptor({
		url: '/staff/profile-img',
		method: 'put',
		headers: {
			'Content-Type': 'multipart/form-data',
		},
		data: request
	})
}

// 알코지니 사용자(의료진) 로그인 기록 조회
// request data
//	- start : 시작 날짜
//	- end : 끝 날짜
// 	- page : 페이지 번호
export function getUserLoginHistoryFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/staff/his/login',
        method: 'get',
		params: request
    })
}

// 의료진 전체 활동 기록 조회 (읽기 전용)
export function getUserActivityHistoryFromAlcohol(request) {
    return AxiosInterceptor({
        url: '/staff/his',
        method: 'get',
        params: request,
        timeout: 15000
    });
}

// 알코지니 사용자 로그인 기록 post
export function postUserLoginHistoryToAlcohol() {
	return AxiosInterceptor({
		url: '/base/recode/login',
		method: 'post'
	})
}

// 알코지니 서비스 회원 탈퇴 (서비스 가입 정보 삭제)
export function deleteUserFromAlcohol() {
	return AxiosInterceptor({
		url: '/signup/dpdtx001Admin',
		method: 'delete'
	})
}
